import React from 'react';
import { RatioTransactionTableInterface } from '../utils';
import { useTranslation } from 'react-i18next';
import { conferencingEntityTransformer } from '../../../utils/transformers';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    ConferencingTableRowInterface,
    generateColumns,
    useStyles,
} from './Conferencing.utils';
import classNames from 'classnames';

const Conferencing: React.VFC<RatioTransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: ConferencingTableRowInterface[] = data.map((item) =>
        conferencingEntityTransformer(item),
    );

    return (
        <DataGrid<ConferencingTableRowInterface>
            data={items}
            dataQa={'conferencing-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default Conferencing;
